import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UserService } from '../../service/user.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  constructor(
    private readonly router: Router,
    private readonly userService: UserService
  ) {
  }

  isLoggedIn(): boolean {
    return this.userService.isUserLoggedIn();
  }

  getUsername(): string {
    return this.userService.getUserLoggedIn()?.username ?? '';
  }
}
